import React from 'react';
import { SwiperSlide } from 'swiper/react';
import OverflowCarousel from 'components/website/OverflowCarousel';
import ArticleCard from './ArticleCard';

import './articles.scss';

const Articles = ({ data }) => {
  return (
    <section id="security-articles" className="security-articles">
      <div className="section-container">
        <div className="section-title">
          <h2 className="title-header-bold-blue">Noticias de seguridad en Bold</h2>
        </div>
        <OverflowCarousel hasPagination showDots showArrows>
          {data.map(({ key, link, image, title, excerpt }) => (
            <SwiperSlide key={key}>
              <ArticleCard {...{ link, image, title, excerpt }} />
            </SwiperSlide>
          ))}
        </OverflowCarousel>
      </div>
      <div className="space"></div>
    </section>
  );
};

export default Articles;
